import axios, { resHandle } from "@/plugins/axios";

/**
 * @description 生成微信二维码
 * @param vCom Vue组件实例
 * @param sceneStr 场景字符串（UUID）
 * @param loading 加载状态
 */
export const generateWechatQrcode = (vCom: any, sceneStr: string, loading?: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    axios.post("api/authx/wechat_qrcode/", {
      action_name: "QR_STR_SCENE",
      expire_seconds: 1000,
      scene_str: sceneStr,
      note: "微信扫码",
      category:'公众号'
    }).then(({ data }) => {
      resHandle(vCom, data, loading).then(() => {
        console.log(888)
        console.log(data)
        resolve(data);
      });
    }).catch(() => {
      loading?.close();
      reject();
    });
  });
};

/**
 * 轮询获取扫码登录结果
 */
export const pollWechatQrcodeStatus = (sceneStr: string): Promise<any> => {
  return axios.get("/api/authx/wechat_qrcode/", {
    params: { scene_str: sceneStr }
  }).then(res => res.data);
}; 